import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { catLabel } from "@/lib/lore";

export const PinDialog = ({ open, onOpenChange, mapId, pin, entities, onSaved }) => {
  const [label, setLabel] = useState(pin?.label || "");
  const [entityId, setEntityId] = useState(pin?.entity_id || "none");
  const [busy, setBusy] = useState(false);
  const sorted = [...entities].sort((a, b) => (a.category === "Location" ? -1 : 0) - (b.category === "Location" ? -1 : 0));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { label, entity_id: entityId === "none" ? null : entityId };
    try {
      if (pin.id) await api.patch(`/pins/${pin.id}`, body);
      else await api.post(`/maps/${mapId}/pins`, { ...body, x_coord: pin.x_coord, y_coord: pin.y_coord });
      onSaved();
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    await api.delete(`/pins/${pin.id}`);
    onSaved();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pin-dialog">
        <form onSubmit={save}>
          <DialogHeader><DialogTitle className="font-display text-3xl">{pin?.id ? "Edit pin" : "Drop a pin"}</DialogTitle></DialogHeader>
          <div className="space-y-4 py-6">
            <div className="text-xs font-mono-lf text-[#A8A090]">x {Math.round(pin.x_coord)} · y {Math.round(pin.y_coord)}</div>
            <div className="space-y-2"><Label>Label</Label><Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Highmoor Keep" data-testid="pin-label-input" /></div>
            <div className="space-y-2">
              <Label>Linked lore entry</Label>
              <Select value={entityId} onValueChange={(v) => { setEntityId(v); if (!label) setLabel(entities.find((x) => x.id === v)?.name || ""); }}>
                <SelectTrigger data-testid="pin-entity-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">— No entry —</SelectItem>
                  {sorted.map((x) => <SelectItem key={x.id} value={x.id}>{x.name} · {catLabel(x.category)}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter className="gap-2">
            {pin?.id && <Button type="button" variant="ghost" className="text-red-400 mr-auto" onClick={remove} data-testid="pin-delete-button">Delete pin</Button>}
            <Button type="submit" disabled={busy} data-testid="pin-save-button">{busy ? "Saving…" : "Save pin"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
